export class LoginManager{

    constructor(logger){
       this.logger=logger;
    }

    processLoginResponse(responseData){
        app.logger.getLogger().info('responseData::'+responseData);
        let resObj={'isNonMigratedUser':false,'isVaildEmail':false,'email':'','isSpocUser':false};
        if(responseData.dmsStatusCode==='USERIDCORRECT_PWDHARDEDCODED_VALIDEMAIL' || responseData.dmsStatusCode==='USERIDCORRECT_NONMIGRATEDUSER'){
            //redirect user to Reset Password page
            LoginManager.setDataInSessionStorage(resObj,true,true,responseData.emailId,false);
            app.appUtil.navigateToFromLogin(app.appUtil.getAppRoutes().LOGIN.RESET_PASSWORD);
        }else if(responseData.dmsStatusCode==='LOGINSUCCESS_NONMIGRATEDUSER'){
           //set state to dispaly error message
           LoginManager.handleCsrErrorMessage.call(this);
        }else if(responseData.dmsStatusCode==='OLDUSERID_PWDINCORRECT_INVALIDEMAIL'){
           //Redirect user to change password page
           LoginManager.setDataInSessionStorage(resObj,true,false,responseData.emailId,false);
           app.appUtil.navigateToFromLogin(app.appUtil.getAppRoutes().LOGIN.CHANGE_PASSWORD);
        }else if(responseData.dmsStatusCode==='OLDUSERID_PWDINCORRECT_VALIDEMAIL'){
           //redirect User to Change Password page with email prrpopulated
           LoginManager.setDataInSessionStorage(resObj,true,true,responseData.emailId,false);
           app.appUtil.navigateToFromLogin(app.appUtil.getAppRoutes().LOGIN.CHANGE_PASSWORD);
        }else if(responseData.dmsStatusCode==='USERIDCORRECT_PWDUNKNOWN_NONMIGRATEDUSER'){
           LoginManager.setDataInSessionStorage(resObj,true,true,responseData.emailId,false);
           app.appUtil.navigateToFromLogin(app.appUtil.getAppRoutes().LOGIN.CHANGE_PASSWORD);
        }else if(responseData.dmsStatusCode==='LOGIN_SUCCESS_TEMPPWD'){
            LoginManager.setDataInSessionStorage(resObj,false,true,responseData.emailId,true);
            // app.appUtil.navigateToFromLogin(app.appUtil.getAppRoutes().LOGIN.CHANGE_PASSWORD);
         }else{
            return true;
        }
    }

    static setDataInSessionStorage(resObj,isNonMigratedUser,isValidEmail,emailValue,isSpocUser){
        resObj.isNonMigratedUser=isNonMigratedUser;
        resObj.isValidEmail=isValidEmail;
        resObj.email=emailValue;
        resObj.isSpocUser=isSpocUser;
        app.appService.setSessionstorage('nonMigratedData',resObj);
    }

    static handleCsrErrorMessage(){
        if(drupalSettings.custom.globalInformation.isFront){
            app.appService.setSessionstorage('errorState', {isCsrError: true});
            app.appUtil.navigateTo(app.appUtil.getAppRoutes().LOGIN.MYSCE_LOGIN);}
        else{
        let userNameObj = { ...this.state.userName };
        userNameObj.value = this.state.userName.value;
        let userErrorMsg = 'Your User ID is the email address you used to register with SCE.';
        userNameObj = this.handleLoginInvalid(userNameObj, userErrorMsg);

        let passwordObj = { ...this.state.password };
        passwordObj.value = this.state.password.value;
        let passwordErrorMsg = 'Password hint: at least 8 characters, 1 number, 1 uppercase,and 1 lowercase.';
        passwordObj = this.handleLoginInvalid(passwordObj, passwordErrorMsg);
        this.setState({ ...this.state, userName: { ...userNameObj }, password: { ...passwordObj }, isCsrError: true });
        }
    }
}